import { render, staticRenderFns } from "./LockedIconV2.vue?vue&type=template&id=ac2b4346&scoped=true"
import script from "./LockedIconV2.vue?vue&type=script&lang=js"
export * from "./LockedIconV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2b4346",
  null
  
)

export default component.exports